module.exports = __webpack_public_path__ + "assets/blog/images/skvizbiz_kursus_fakturaarkivet.jpg";